import { sample, shuffle, times } from 'lodash-es';

export default
{
    /**
     * Generate a random password
     *
     * @param {Array} array
     */
    password(ln = 12, excludeSymbols = true) 
    {
        const lowerCaseLetters = 'abcdefghjkmnpqrstuvwxyz';
        const upperCaseLetters = 'ABCDEFGHJKMNPQRSTUVWXYZ';
        const numbers = '023456789';
        const symbols = '-_.@&$';

        // Si excludeSymbols === true => on exclut les symboles
        const all = excludeSymbols
            ? lowerCaseLetters + upperCaseLetters + numbers
            : lowerCaseLetters + upperCaseLetters + numbers + symbols;

        // Élément obligatoires
        const mandatory = [
            sample(lowerCaseLetters),
            sample(upperCaseLetters),
            sample(numbers),
        ];

        if(!excludeSymbols) 
        {
        // Si on n’exclut pas => ajouter un symbole obligatoire
            mandatory.push(sample(symbols));
        }

        // Garantir la longueur minimale
        if(ln < mandatory.length) 
        {
            ln = mandatory.length;
        }

        const password = shuffle([
            ...mandatory,
            ...times(ln - mandatory.length, () => sample(all)),
        ]).join('');

        return password;
    },

    removeAccents(str)
    {
        const charMap = {
            // French / German / Nordic
            'æ': 'ae', 'Æ': 'AE',
            'œ': 'oe', 'Œ': 'OE',
            'ß': 'ss',
            'ø': 'o', 'Ø': 'O',
            'å': 'a', 'Å': 'A',
            'ç': 'c', 'Ç': 'C',

            // Polish
            'ł': 'l', 'Ł': 'L',

            // Croatian / Vietnamese / Icelandic
            'đ': 'd', 'Đ': 'D',
            'ð': 'd', 'Ð': 'D',

            // Czech / Slovak / Hungarian
            'ť': 't', 'Ť': 'T',
            'ď': 'd', 'Ď': 'D',
            'ň': 'n', 'Ň': 'N',
            'ő': 'o', 'Ő': 'O',
            'ű': 'u', 'Ű': 'U',

            // Romanian
            'ș': 's', 'Ș': 'S',
            'ț': 't', 'Ț': 'T',
        };

        // Replace special characters manually
        str = str.replace(/[^A-Za-z0-9]/g, c => charMap[c] || c);

        // Remove combining accent marks (e.g. é -> e + ́)
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
};
